module.exports = __webpack_public_path__ + "img/QR-Scan.5cda13e8.svg";